// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1BN-6","left":"InfoRow_left__1yw_2"};